<template>
  <div class="pricingSuccessful">
    <div class="headerView">
      <div class="title_">您的文章定价完成，发给刊社</div>
      <div class="content_">
        <div class="left_">
          <div class="webUrl_" @click="openUrl(pageData.webUrl)">
            {{ pageData.webUrl }}
          </div>

          <!-- <div class="codeView">
            <div class="codeTitle">提取码</div>
            <div class="codeContent">
              {{ pageData.code }}
            </div>
          </div> -->
        </div>

        <div class="right_" @click="copyUrl(pageData.webUrl)">复制链接</div>
      </div>
    </div>

    <div class="articleView">
      <div class="articleTopView">
        <div class="title_">{{ pageData.detailData.title }}</div>
        <div class="author_">
          <!-- <div>著作权人：杨劲松 、王某某</div> -->
          <div>作者：{{ pageData.detailData.author }}</div>
        </div>
      </div>
      <div class="content_" v-html="pageData.detailData.content"></div>
    </div>
  </div>
</template>

<script>
import { articleGetArticleInfo } from "../api/interfaceList";
import { ElMessage } from "element-plus";
import { reactive } from "vue";
import Cookies from "js-cookie";
import { useRoute } from "vue-router";

export default {
  name: "pricingSuccessful",
  components: {},
  setup() {
    const route = useRoute();
    let pageData = reactive({
      webUrl: "",
      code: "",
      content: "",
      detailData: "",
    });

    function openUrl(e) {
      window.open(e, "_blank");
    }

    function copyUrl(value) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", value);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      ElMessage({
        message: "复制成功",
        type: "success",
      });
    }
    articleGetArticleInfo({
      userCode: JSON.parse(Cookies.get("userInformation")).userCode,
      worksCode: route.query.worksCode,
    }).then((res) => {
      if (res.code == 1) {
        pageData.webUrl = `http://market.qikan.cn/#/articleDetails?worksCode=${route.query.worksCode}`;
        pageData.detailData = res.data;
      } else {
        ElMessage({
          message: res.message,
        });
      }
    });
    return {
      pageData,
      openUrl,
      copyUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
.pricingSuccessful {
  .articleView {
    padding: 40px 155px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 8px;
    margin-top: 24px;
    .articleTopView {
      .title_ {
        font-size: 30px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        line-height: 36px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .author_ {
        display: flex;
        align-items: center;
        margin: 10px 0 30px 0;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 20px;
        div {
          margin-right: 40px;
        }
        div:last-of-type {
          margin-left: 0;
        }
      }
    }
    .content_ {
      font-size: 15px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
      line-height: 24px;
      margin-top: 24px;
    }
  }
  .headerView {
    width: 100%;
    background: #cce6ff;
    border-radius: 6px;
    padding: 20px 30px;
    box-sizing: border-box;
    .content_ {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left_ {
        display: flex;
        align-items: center;
        .codeView {
          display: flex;
          align-items: center;
          margin-left: 40px;
          .codeContent {
            width: 116px;
            height: 40px;
            line-height: 40px;
            background: #ffffff;
            border-radius: 6px;
            border: 1px solid #cccccc;
            padding: 0 8px;
            box-sizing: border-box;
            font-size: 13px;
            font-family: AlibabaPuHuiTiR;
            color: #303133;
          }
          .codeTitle {
            font-size: 12px;
            font-family: AlibabaPuHuiTiM;
            color: #1f2d66;
            margin-right: 10px;
          }
        }
        .webUrl_ {
          width: 316px;
          height: 40px;
          background: #ffffff;
          border-radius: 6px;
          border: 1px solid #cccccc;
          line-height: 40px;
          text-align: center;
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          text-align: left;
          padding: 0 8px;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      .right_ {
        width: 160px;
        height: 40px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #008aea;
        border-radius: 6px;
        cursor: pointer;
      }
      .right_:hover {
        background: #6dbbfc;
      }
    }
    .title_ {
      font-size: 12px;
      font-family: AlibabaPuHuiTiM;
      color: #1f2d66;
      line-height: 32px;
      font-weight: 700;
      margin-bottom: 4px;
    }
  }
}
</style>
